import { useState, useEffect } from "react";
import axiosInstance from "../../services/axios-instance";
import { FilesInterface } from "../../interface/filesInterface";
import TableFiles from "../elements/TableFiles";
import { FILES } from "../../services/endpoints";

function Documents() {
    const [allFiles, setAllFiles] = useState<FilesInterface[]>([]);

    const cellNames = {
        cellOne: "Title",
        cellTwo: "Description",
        cellTree: "Type",
        cellFour: "File",
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const responseAllFiles = await axiosInstance.get(FILES);
                setAllFiles(responseAllFiles.data.data);
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, []);

    return (
        <>
            <TableFiles data={allFiles} cellNames={cellNames} />
        </>
    );
}

export default Documents;
